module.exports = __webpack_public_path__ + "media/images/presentation_immagration_entrepreneur_quebec-9ed88f0a1f3c07382c6fe6e36bfcfaff.pdf";